export default __webpack_public_path__ + "static/oticas-diniz-01032ce93bc5e036aaac8eef532b5fc8.jpg";